import React from 'react'
import PropTypes from 'prop-types'

import { Switch } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

// A boolean field rendered as a labelled switch, for use as a uikit Form
// field's `render`.
//
// Form cannot render a boolean from the schema alone. prepareSchema gives any
// boolean-default field `enum: [true, false]`, Form turns an enum into
// `options`, and that branch is chosen ahead of every type branch - so the
// field became a react-select handed raw booleans, with no value/label for it
// to draw from. It rendered blank and had nothing selectable. `render` is
// checked before `options`, so supplying one takes the field down this path.
export const BooleanRule = ({ name, label, hint, item, onChange, disabled }) => (
  <div className="segment-id-rule">
    <Switch
      checked={!!item[name]}
      onChange={() => {
        if (!disabled) onChange(!item[name], name)
      }}
    />
    <div className="segment-id-rule__text">
      <span className="segment-id-rule__label">{label}</span>
      <span className="segment-id-rule__hint">{hint}</span>
    </div>
  </div>
)

BooleanRule.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  item: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

// Build the Form field descriptor. The boolean goes out as `value` with no
// formattedValue, because EntityEditForm's onChange assigns
// `formattedValue || value` - which stores false correctly, where passing it as
// formattedValue would not.
export const booleanRule = (name, label, hint) => {
  // named so react/display-name doesn't read this Form callback as an anonymous
  // component definition
  const render = (formProps) => (
    <BooleanRule key={name} name={name} label={label} hint={hint} {...formProps} />
  )
  render.displayName = `BooleanRule(${name})`

  return { name, render }
}
